export default "/success-modal-icon.b33b69e147961568af9cccfd8a0befa7.svg";